import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useWorkflowSteps = (id?: string) => {
  const key = id
    ? JSON.stringify([`all-roles-${id}`])
    : JSON.stringify(["all-roles"]);
  return useQuery(
    key,
    () => {
      return wf.getWorkflowRoles(id!);
    },
    {
      cacheTime: 5 * 60 * 1000,
      staleTime: 5 * 60 * 1000,
      enabled: !!id,
    }
  );
};

export default useWorkflowSteps;
